import { ToastNotifications } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { GlobalStyle } from '../../assets';
import AssetForms from './components/container/AssetForms';
import ErrorBoundary from './components/container/ErrorBoundary';
import { setInternal } from './redux/internal.slice';
import setupStore from './redux/store';

function Forms(props) {
  const { accountId, accountTimezone, assetId, authenticityToken, libraryId, user } = props;

  const [store] = useState(setupStore());

  useEffect(() => {
    const internalValues = {
      authenticityToken,
      accountId,
      accountTimezone,
      user,
      libraryId,
      assetId,
    };

    store.dispatch(setInternal(internalValues));
  }, []);

  return (
    <>
      <GlobalStyle />
      <Provider store={store}>
        <Router>
          <ToastNotifications />
          <ErrorBoundary>
            <Switch>
              <Route
                exact={false}
                path={`/libraries/${libraryId}/assets/${assetId}/forms`}
                render={() => <AssetForms />}
              />
            </Switch>
          </ErrorBoundary>
        </Router>
      </Provider>
    </>
  );
}

Forms.propTypes = {
  accountId: PropTypes.number.isRequired,
  accountTimezone: PropTypes.string.isRequired,
  assetId: PropTypes.string.isRequired,
  authenticityToken: PropTypes.string.isRequired,
  libraryId: PropTypes.string.isRequired,
  user: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
};

export default Forms;
